export enum ContextTypes {
  OFFER = 'offer',
  OFFERGROUP = 'offerGroup',
  PROMOS = 'promos'
}
